module.exports = __webpack_public_path__ + "static/media/case3.54d8f8e7.png";